import { AppLocation } from 'src/navigation/appLocations'
import * as Routes from 'src/navigation/urls'

/**
 * BillPay flat route tree — single source for the BillPay tabbed family.
 * See src/navigation/AGENTS.md for the route-tree derivation pattern.
 */

export interface BillPayFamilyTabNode {
  /** Stable key used for active-tab detection. */
  key: string
  /** AppLocation that drives sidenav active state via locationHooks. */
  appLocation: AppLocation
  /** Exact URL pattern, e.g. `/billpay/all`. */
  path: string
}

export const billPayRouteTree = {
  family: {
    /** `/billpay` — redirects to the All tab. */
    rootPath: Routes.billPayUrl(),
    rootAppLocation: AppLocation.BillPay,
    redirectTo: Routes.billPayAllUrl(),
    tabs: [
      {
        key: 'all',
        appLocation: AppLocation.BillPayAll,
        path: Routes.billPayAllUrl(),
      },
      {
        // Legacy parity: needs-approval carried no id, resolving to Home; mapping it
        // explicitly here keeps that and out-ranks the retained legacy :id route.
        key: 'needsapproval',
        appLocation: AppLocation.Home,
        path: Routes.billPayNeedsApprovalUrl(),
      },
    ] as BillPayFamilyTabNode[],
  },
}

/**
 * Family GATE paths (root + tabs), enumerated so each out-specifies the
 * retained legacy /billpay/:id detail route.
 */
export const billPayFamilyGatePaths: string[] = [
  billPayRouteTree.family.rootPath,
  ...billPayRouteTree.family.tabs.map((t) => t.path),
]
